/* © CNES */
import { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { ConfigContext } from '../../context/ConfigContext';
import { AppHeader } from '../appHeader/AppHeader';
import { PageHeader } from '../shared/PageHeader/PageHeader';
import { ItemsInformationContainer } from './ItemsInformationContainer/ItemsInformationContainer';
import './MyInformation.scss';

/**
 * MyInformation Page.
 * @returns Element
 */
export const MyInformation = () => {
  const context = useContext(ConfigContext);
  const isAuthDisabled = process.env.NODE_ENV !== 'production';

  if (!isAuthDisabled && !context.userLoggedIn.email) {
    return <Navigate to="/" replace />;
  }

  return (
    <>
      <AppHeader tabindex={99} />
      <div className="MyInformationContainer">
        <PageHeader pageTitle="My Profile" isMyDataPage={false} />
        <ItemsInformationContainer />
      </div>
    </>
  );
};
